// removed by extract-text-webpack-plugin
module.exports = {"form":"k1_k2","input":"k1_ip","questionSet":"k1_hk","stars":"k1_ei","adjective":"k1_k3","bubble":"k1_k4","breaker":"k1_gk","submit":"k1_k5","outOfFive":"k1_k6","summary":"k1_j0","summarySection":"k1_k7","combinedRating":"k1_k8","starRating":"k1_k9"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventReviewForm/styles.module.css
// module id = 1321
// module chunks = 27